import React from 'react'
import "./App.css"
import Banner from './Components/Banner/Banner'
import Navbar from './Components/Navbar/Navbar'
import Rowpack from './Components/Rowpack/Rowpack'





export default function App() {
  return (
    <div>
      <Navbar/>
     <Banner/>
     <Rowpack/>
     
 
    

    </div>
  )
}
